import { writable } from 'svelte/store';

export const canvasStore = writable({
  canvas: null,
  selectedMenu: 'templates'
});
